module.exports = __webpack_public_path__ + "img/trade-img-bjiu-zh.a968ecea.png";